import React from 'react';
import { Star, Quote } from 'lucide-react';
import { testimonials } from '../mock';

const Testimonials = () => {
  return (
    <section id="testimonials" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <div className="inline-flex items-center gap-2 bg-pink-50 border border-pink-200 text-pink-600 rounded-full px-3 py-1 text-xs font-semibold tracking-wider mb-4">
            LOVE NOTES
          </div>
          <h2 className="font-display text-4xl md:text-5xl font-bold text-gray-900">
            What Our <span className="gradient-text">Clients Say</span>
          </h2>
          <p className="mt-4 text-gray-600 text-lg">
            Real experiences from satisfied customers
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {testimonials.map((t) => (
            <div
              key={t.id}
              className="card-lift relative bg-gradient-to-br from-white to-pink-50/40 rounded-2xl p-6 border border-pink-100 shadow-sm"
            >
              <Quote className="absolute top-4 right-4 h-8 w-8 text-pink-200" />
              <div className="flex items-center gap-1 mb-4">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <Star key={i} className="h-4 w-4 text-pink-500 fill-pink-500" />
                ))}
              </div>
              <p className="text-gray-700 leading-relaxed mb-6">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="flex items-center gap-3 pt-4 border-t border-pink-100">
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-pink-200 to-rose-200 flex items-center justify-center text-pink-700 font-semibold">
                  {t.name.charAt(0)}
                </div>
                <div>
                  <div className="font-semibold text-gray-900 text-sm">{t.name}</div>
                  <div className="text-xs text-gray-500">{t.time}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
